<template>

  <v-container>

      
  </v-container>
</template>

<script>

export default {

  name: 'Home',

  created() {
    window.location.href = "https://www.microcise.co.uk/";
  }, 
  async mounted() {
   
    }         
}
</script>



